import * as React from 'react';
import { MaskedTextBox, MaskedTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { FieldProps } from 'react-jsonschema-form-bs4';

export default class Healthcard extends React.Component<FieldProps, any> {

    constructor(props: FieldProps) {
        super(props);
        this.state = { ...props.formData };
    }

    onChange(name: string) {
        return (event: MaskedTextBoxChangeEvent) => {
            this.setState({ [name]: event.target.value.replace(/_/g, "") });
            setImmediate(() => this.props.onChange(this.state[name]));
        };
    }

    public render() {
        return <React.Fragment>
            <div className="input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text">{this.props.schema.title || "Health Card Number"}{this.props.required && <span style={{ color: '#dc3545' }}>*</span>}</span>
                </div>
                <MaskedTextBox
                    disabled={this.props.disabled}
                    readonly={this.props.readonly}
                    mask="0000-000-000-LL"
                    placeholder="0000-000-000-AA"
                    value={this.state[this.props.name]}
                    onChange={this.onChange(this.props.name)}
                />
            </div>
        </React.Fragment>;
    }
}
